import { ProfileService } from "@/services/profile.service";
import { tenantConfigs } from "@/configs/tenantConfig";
import { normalizeWholesalersDealersList } from "@/utils/normalizeWholesalersDealers";
import {
  isProfileHashId,
  resolveProfileHashIdFromStore,
} from "@/utils/resolveProfileHashId";

/**
 * @deprecated On profile screens use fetchProfileFormData / loadProfileForm instead.
 * Kept for non-profile flows that only need auth/me.
 */
export async function fetchUserProfile(store) {
  try {
    if (!store.getters.getIsMePending) {
      await store.dispatch("me");
    }
  } catch (error) {
    console.log(error);
  }
}

/** @see useProfileFormData — preferred in Vue components */
export async function fetchProfileFormData(store, options = {}) {
  try {
    const response = await store.dispatch("loadProfileFormData", {
      includeWholesalers: options.includeWholesalers !== false,
    });

    const dealers = normalizeWholesalersDealersList(
      store.getters.getMe?.wholesalers_dealers,
    );
    if (!dealers.length && !store.getters.getIsMePending) {
      await store.dispatch("me");
    }

    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function afterSuccess(
  user_id,
  profile_id,
  fillPercent,
  plainId,
  store
) {
  try {
    const resolvedUserId = user_id ?? store.getters.getMe?.id ?? null;
    const resolvedProfileId =
      (isProfileHashId(profile_id) ? profile_id : null) ??
      resolveProfileHashIdFromStore(store);

    if (!isProfileHashId(resolvedUserId) || !resolvedProfileId) {
      console.warn(
        "storeProfilePercentage skipped: missing user_id or profile_id",
      );
      return;
    }

    await store.dispatch("storeProfilePercentage", {
      user_id: resolvedUserId,
      profile_id: resolvedProfileId,
      percentage: fillPercent,
    });

    const tenantId = String(store?.getters?.tenantId || "").toUpperCase();
    const tenantConfig =
      tenantConfigs.tenants[tenantId] || tenantConfigs.tenants.DEFAULT;
    const canStoreFullProfilePoints = Boolean(
      tenantConfig?.storeFullProfilePoints
    );

    if (fillPercent == 100 && canStoreFullProfilePoints) {
      await ProfileService.storeFullProfilePoints(plainId);
    }
  } catch (error) {
    console.log(error);
  }
}
